import axios from 'src/api/axiosInstances/privateAxiosInstancePrice';
import PriceHistoryList from '../types/PriceHistoryList';

type AsyncResponse = {
  headers: {
    location: string;
  };
};

type AsyncResponseData = {
  data: PriceHistoryList.Response | null;
  status: number;
};

export const getPriceHistory = (fileName: string): Promise<AsyncResponseData> => {
  return axios
    .get(`/oc/asynch?fileName=${fileName}`)
    .then((response: AsyncResponseData) => {
      return { status: response.status, data: response.data };
    })
    .catch((error) => {
      if (error.response) {
        return { status: error.response.status, data: null };
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error during request setup:', error.message);
      }
      throw error;
    });
};

export const getPriceHistoryAsync = (params: PriceHistoryList.Request): Promise<AsyncResponse> => {
  return axios.get('qm/product/pricehistory', { params });
};
